import './AddProduct.scss';
import Component from './AddProduct.js';
export default Component;
